// @ts-check
import "jquery";
import "@fancyapps/fancybox";
import imagesLoaded from "imagesloaded";
import { throttle, debounce } from "throttle-debounce";
import { ElementObserver } from "viewprt";
import "./compat";
import { addAgentClasses, getSupports, hasSupport } from "./browser";
import { isNumeric, getSeparator } from "./numbers";
import "./cssVars";
import { CountUp } from "countup.js";
import { setCssVar } from "./cssVars";
import objectFitImages from "object-fit-images";

export default class Circular {
  constructor() {
    this.__NS__ = "Circular";

    this._detectSupports();
    this._detectAgent();
    this._detectScrolled();
    this._detectSticky();

    this.scrollSpy = {
      selector: "body",
      target: "#nav-main"
    };

    // elements
    this.elements = {};
    this.elements.header = $(".banner");
    if (!$(".bar-top", this.elements.header).length) {
      this.elements.bar_top = $(".bar-top");
    }
    this.elements.cookie_bar = $("#cookie-notice");
    this.elements.nav = $("#nav-main");
    this.elements.main = $(".main");

    this.anchorLinks = [];

    this.state = {};

    this._addDefinitionListNavbar();
    this._setDefaultClasses();
    this._checkScrollAnchors();
    this._setMultiPadded();
    this._initHamburger();
    this._initLightbox();
    this._initCssGrid();
    this._setImageFocus();
    this._setImageBlend();
    this._fixImageSize();
    // this._fixEmailBreaks();
    this._setScrollHint();
    this._addScrollTop();
    this._autoHideOnScroll();
    this._fixSVG();

    $("p,ol,ul")
      .filter(":empty")
      .remove();

    // init events
    this.initEvents();

    $("html")
      .removeClass("no-js")
      .addClass("js");
  }

  finalize() {
    this._setSharrifClasses();
    this._setTargetBlank();
    this._setFileSizeInfo();
    this._setImageFocus();

    this._animateLists();
    this._animateOnVP(".animate-on-view");
    this._initUpCount();

    this._finalizeParallax();
    this._finalizeBlurUp();

    objectFitImages();

    $("html").addClass("loaded");
  }

  initEvents() {
    this._initAttributeTrigger();
    this._initScrollSpy();
    this._initSmoothScroll();
    this._initFlipping();

    this._fixFullHeightRow();
    $(window).on(
      "resize." + this.__NS__,
      debounce(200, $.proxy(this._fixFullHeightRow, this))
    );
    $(document).on(
      "setCookieNotice showCookieNotice",
      debounce(200, $.proxy(this._fixFullHeightRow, this))
    );
  }

  _detectSupports() {
    getSupports();
  }

  /**
   * Add classes based on browser
   */
  _detectAgent() {
    addAgentClasses();
  }

  /**
   * Add class if page is scrolled
   */
  _detectScrolled() {
    var $window = $(window);
    var scrollOffset = $window.data("scroll-offset") || 10;
    var currentScroll = $window.scrollTop();
    $window.on(
      "scroll",
      throttle(200, function() {
        var scrollTop = $window.scrollTop();
        var delta = Math.abs(currentScroll - scrollTop);
        if (delta < (window.innerHeight * 0.1) && 0 !== scrollTop) {
          return;
        }
        $("html").toggleClass(
          "is-scrolled",
          scrollTop > scrollOffset
        );
        currentScroll = scrollTop;
      })
    );
  }

  /**
   * Add class if element is stuck
   */
  _detectSticky() {
    var $window = $(window);
    var scrollOffset = $window.data("scroll-offset") || 10;
    var currentScroll = $window.scrollTop();
    $window.on(
      "scroll",
      throttle(
        200,
        function() {
          var scrollTop = $window.scrollTop();
          var delta = Math.abs(currentScroll - scrollTop);
          if (delta < (window.innerHeight * 0.1) && 0 !== scrollTop) {
            return;
          }
          $(".sticky-top, .fixed-top").toggleClass(
            "stuck",
            scrollTop > scrollOffset
          );
          currentScroll = scrollTop;
        }
      )
    );
  }

  _autoHideOnScroll() {
    const $window = $(window);
    const $document = $(document);
    const $main = $(".main");
    const selector = ".auto-hide-on-scroll";
    const throttleTimeout = 500;
    const elClassHidden = "is-hidden";

    let wHeight = $window.height();
    let wScrollCurrent = 0;
    let wScrollDiff = 0;
    let wScrollBefore = 0;
    let dHeight = 0;
    let offset = 0;
    let offsetVariable = false;

    if ($main && $(".row-o-full-height", $main)) {
      offsetVariable = true;
    }

    const $element = $(selector);

    $window.on(
      "scroll.auto-hide",
      throttle(throttleTimeout, function() {
        dHeight = $document.height();
        wHeight = $window.height();
        wScrollCurrent = $window.scrollTop();
        wScrollDiff = wScrollBefore - wScrollCurrent;

        if (offsetVariable) {
          offset = wHeight;
        }

        // scrolled to the very top; element sticks to the top
        if (wScrollCurrent <= offset) {
          $element.removeClass(elClassHidden);
        }
        // scrolled up; element slides in
        else if (wScrollDiff > 0 && $element.hasClass(elClassHidden)) {
          $element.removeClass(elClassHidden);
        }
        // scrolled down
        else if (wScrollDiff < 0) {
          // scrolled to the very bottom; element slides in
          if (
            wScrollCurrent + wHeight >= dHeight &&
            $element.hasClass(elClassHidden)
          ) {
            $element.removeClass(elClassHidden);
          }
          // scrolled down; element slides out
          else {
            $element.addClass(elClassHidden);
          }
        }

        wScrollBefore = wScrollCurrent;
      })
    );
  }

  _animateLists() {
    const _ = this;
    const animatedList = document.querySelectorAll("[data-animate-list]");
    animatedList.forEach(list => {
      const nodes = Array.from(list.children);
      const factor = list.dataset.animationDelay || 0.3;
      nodes.forEach((node, i) => {
        node.style.setProperty("--delay", parseFloat(i * factor) + "s");
        node.dataset.animation = list.dataset.animateList;
      });
      _._animateOnVP(nodes, list.dataset.animateList || "");
    });
  }

  _animateOnVP(elements, animation) {
    if ("string" === typeof elements || !elements) {
      elements = document.querySelectorAll(
        "string" === typeof elements ? elements : ".animate-on-view"
      );
    }
    if ("undefined" === typeof animation) {
      animation = null;
    }
    const getAnimationClass = (item, animation) => {
      const animationClass = (Array.from(item.classList)
        .map(className => {
          return className.match(/^aov-/) && className.replace(/^aov-/, "");
        })
        .filter(n => n) || [null])[0];
      if (animationClass) {
        item.classList.remove(`aov-${animationClass}`);
        item.dataset.animation = animationClass;
      }
      return item.dataset.animation || animation || null;
    };
    elements.forEach(item => {
      const elementAnimation = getAnimationClass(item);
      const elementObserver = ElementObserver(item, {
        once: true,
        offset: -100,
        onEnter(element) {
          if (elementAnimation) {
            element.classList.add(elementAnimation);
          }
          element.classList.add("animated");
        }
      });
      elementObserver.activate();
    });
  }

  _initUpCount(elements) {
    if ("string" === typeof elements || !elements) {
      elements = document.querySelectorAll(
        "string" === typeof elements ? elements : "[data-count]"
      );
    }
    const defaultOptions = {
      useEasing: true,
      easingFn: (t, b, c, d) => {
        const ts = (t /= d) * t;
        const tc = ts * t;
        return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
      },
      useGrouping: true,
      separator: getSeparator({
        type: "group"
      }),
      decimal: getSeparator({
        type: "decimal"
      })
    };
    const defaultParams = {
      startVal: 0,
      decimals: 0,
      duration: 2,
      delay: 0,
      offset: 0
    };
    elements.forEach(item => {
      const params = Object.assign(
        {},
        defaultParams,
        Object.filter(
          {
            startVal: item.dataset.countStart,
            endVal: item.dataset.count || item.innerText,
            decimals: item.dataset.countDecimals,
            duration: item.dataset.countDuration,
            delay: item.dataset.countDelay,
            offset: item.dataset.countOffset
          },
          ([name, value]) => name && value && value.trim().length
        )
      );
      if (params.delay) {
        if (60 >= params.delay) {
          params.delay *= 1000;
        }
      }
      const options = defaultOptions;
      const largeNumber = params.end > 1000;
      const counter = new CountUp(
        item,
        params.startVal,
        largeNumber ? params.endVal - 100 : params.endVal,
        params.decimals,
        params.duration,
        options
      );
      if (!counter.error) {
        const elementObserver = ElementObserver(item, {
          once: true,
          offset: params.offset,
          onEnter() {
            setTimeout(() => {
              counter.start(
                largeNumber ? () => counter.update(params.endVal) : null
              );
            }, params.delay);
          }
        });
        elementObserver.activate();
      }
    });
  }

  _fixSVG(svg) {
    if (!svg) {
      svg = document.querySelectorAll(".svg-wrapper > svg");
    }
  }

  _finalizeParallax() {
    const elements = document.querySelectorAll(
      '[data-vc-parallax-image][style*="data:image/svg"]:not(.parallax-loaded)'
    );
    elements.forEach(item => item.classList.add("parallax-loaded"));
  }

  _finalizeBlurUp() {
    const blurredContainer = document.querySelectorAll(".blur-up");
    const imgLoad = imagesLoaded(blurredContainer);
    imgLoad.on("progress", (instance, current) => {
      const container = current.img.parentElement;
      container.classList.add(current.isLoaded ? "loaded" : "error");
    });
  }

  /**
   * Add soft-break in email links
   *
   * @param {array|null} emails Array of email links
   */
  _fixEmailBreaks(emails) {
    if (!emails) {
      emails = document.querySelectorAll('a[href^="mailto:"]');
    }
    const regex = /@(?!(&#8203;|<wbr>))/g;
    emails.forEach(item => {
      item.innerHTML = item.innerHTML.replace(regex, `@&#8203;`);
    });
  }

  /**
   * Fix object fit
   *
   * @param {array|null} images Array of images to fix object fit
   */
  _fixObjectFit(images) {
    if (!images) {
      images = $("img");
    }
    $.each(images, function() {
      const $container = $('<div class="object-fit-wrapper" />').css({
        "background-image": 'url("' + this.src + '")',
        "background-position": "50% 50%",
        "background-size": "cover"
      });
      const $image = $(this);
      const rounded = this.className.match(/rounded(-circle)?/g);
      if (rounded) {
        $container.addClass(rounded[0]);
      }
      $image.wrap($container);
      this.style.opacity = 0;
    });
  }

  _fixImageSize(images) {
    if (!images) {
      images = $('img[class*="size-"]');
    }
  }

  _getCssVar(property, element) {
    return getCssVar(property, element);
  }

  _setCssVar(property, value, element) {
    return setCssVar(property, value, element);
  }

  _fixFullHeightRow() {
    const _ = this;

    this.__getFullHeightOffset();

    if (!hasSupport("cssVars")) {
      const $fullHeightRows = $(".row-o-full-height");
      $fullHeightRows.each($.proxy(_.__setViewportHeightWOHeader, _));
    }
  }

  __getCookieBarHeight() {
    let offset = 0;
    if (this.elements.cookie_bar.length) {
      const offset = parseFloat(this.elements.cookie_bar.outerHeight(true), 10);
      this._setCssVar("--cookie-bar-height", offset + "px");
      window.console.log("CookieBar, offset", offset);
    }
    return parseFloat(offset, 10);
  }

  __getFullHeightOffset() {
    let offset = 0;
    if (
      "fixed" !== this.elements.header.css("position") &&
      !this.elements.header.get(0).className.match(/\bfixed/)
    ) {
      offset = parseFloat(this.elements.header.outerHeight(true), 10);
      offset += parseFloat(this.elements.header.css("border-top-width"), 10);
      if (this.elements.bar_top.length) {
        offset += parseFloat(this.elements.bar_top.outerHeight(true), 10);
      }
    }
    const $body = $("body");
    if ($body.hasClass("passpartout")) {
      offset += parseFloat($body.css("border-top-width"), 10);
      offset += parseFloat($body.css("border-bottom-width"), 10);
    }
    if (this.elements.cookie_bar.length) {
      const cookieBarHeight = parseFloat(
        this.elements.cookie_bar.outerHeight(true),
        10
      );
      this._setCssVar("--cookie-bar-height", cookieBarHeight + "px");
      offset += parseFloat(cookieBarHeight, 10);
    }
    this._setCssVar("--fullheight-offset", offset + "px");
    return offset;
  }

  __setViewportHeightWOHeader(i, element) {
    if (!this.elements.header) {
      return;
    }
    const offset = this.__getFullHeightOffset() || 0;
    $(element).css(
      "min-height",
      ((window.innerHeight - offset) / window.innerHeight) * 100 + "vh"
    );
  }

  _addScrollTop(container) {
    if (!container) {
      container = document.querySelector("body");
    }
    const selector = "scroll-top";
    let button = document.querySelectorAll(selector);
    if (!button.length) {
      button = $(
        `<button class="btn btn-primary scroll-top d-none" data-scroll="up" type="button" aria-hidden="true"><i class="fas fa-chevron-up"></i></button>`
      )
        .appendTo(container)
        .get(0);
    }
    const $button = $(button);
    const $window = $(window);
    const factor = 1.5;
    $window.on(
      "scroll.scroll-top",
      throttle(200, function() {
        $button.toggleClass(
          "d-none",
          $window.scrollTop() < $window.height() * 0.8
        );
      })
    );
    $button.on("click.scroll-top", function() {
      $("html, body").animate(
        {
          scrollTop: 0
        },
        500
      );
    });
  }

  _setScrollHint() {
    const _ = this;
    const $fullHeightRow = $(
      "> .row-o-full-height:first-child",
      _.elements.main
    );
    if (!$fullHeightRow.length) {
      return;
    }
    // const iconClass = 'far fa-angle-down';
    const iconClass = "fal fa-chevron-circle-down fa-2x";
    const $scrollHint = $(
      `<a class="scroll-hint position-absolute p-4 text-center fixed-bottom"><i class="${iconClass}"></i></a>`
    );

    $scrollHint.addClass("animated infinite bounce");
    $fullHeightRow.append($scrollHint);

    const $nextRow = $scrollHint.closest(".row").next(".row");
    if (!$nextRow.attr("id")) {
      $nextRow.attr("id", "scrollRow");
    }
    $scrollHint.attr("href", `#${$nextRow.attr("id")}`);

    const $window = $(window);
    const factor = 1.5;
    $window.on(
      "scroll.scroll-hint",
      throttle(200, function() {
        const position = ($window.scrollTop() * factor) / $window.height();
        $scrollHint.css("opacity", 1 - position);
      })
    );
  }

  _checkScrollAnchors() {
    var _ = this;
    _.scrollSpy.container = $(_.scrollSpy.selector);
    if (this.scrollSpy.container.length) {
      _.scrollSpy.container.attr("data-offset", _.__getFullHeightOffset());
      _.scrollSpy.anchors = $(
        'a[href^="#"], a[href^="/#"]',
        _.elements.nav
      ).filter(function() {
        if ($(this.hash, _.scrollSpy.container).length) {
          if ("/" === $(this).attr("href")[0]) {
            $(this)
              .attr(
                "href",
                $(this)
                  .attr("href")
                  .substr(1)
              )
              .removeClass("active");
          }
          return true;
        }
        return false;
      });
    }
  }

  __mapAttributeToCssVar(item, map) {
    Object.keys(map).forEach(key => {
      let value;
      if (item.dataset && item.dataset[key]) {
        value = item.dataset[key];
      } else {
        value = $(item).data(key);
      }
      if (value) {
        item.style.setProperty(map[key], value);
      }
    });
  }

  _initHamburger() {
    const activeClass = "is-active";
    $(".hamburger").on("click.hamburgers", function() {
      const $hamburger = $(this);
      $hamburger.toggleClass(activeClass);
    });
  }

  _initLightbox() {
    const options = {
      lang: document.querySelector("html").lang.substr(0, 2) || "en",
      toolbar: false,
      loop: true,
      caption: (instance, item) => {
        let caption = $(item.opts.$orig).data("caption") || "";
        // if (item.type === 'image') {
        //   caption = (caption.length ? caption + '<br />' : '') + `<a href="${item.src}">Download</a>`;
        // }
        return caption;
      }
    };
    const prepareItem = ({ item, container }) => {
      const $link = $("a", item);
      if ($link.is(".link-overall, .stretched-link")) {
        return;
      }
      const caption = $(".gallery-caption", item).addClass("d-none");
      $link.attr({
        "data-fancybox": container.id || "",
        "data-caption": caption.length ? caption.html().trim() : null
      });
    };
    $(".gallery, .carousel").each((i, container) => {
      $(".gallery-item, .carousel-item", container).each((i, item) =>
        prepareItem({
          item,
          container
        })
      );
    });
    $("[data-fancybox]").fancybox(options);
  }

  _initCssGrid() {
    const gridAttributeMap = {
      gridColumns: "--grid-columns",
      gridRows: "--grid-rows",
      gridGap: "--grid-gap",
      gridItemHeight: "--grid-item-height"
    };

    const gridItemAttributeMap = {
      gridItemColor: "--grid-item-color",
      gridItemHeight: "--grid-item-height",
      gridItemBackgroundColor: "--grid-item-background-color",
      gridItemIconColor: "--icon-color"
    };

    let _ = this;

    document.querySelectorAll(".grid, .masonry").forEach(item => {
      _.__mapAttributeToCssVar(item, gridAttributeMap);
    });

    document.querySelectorAll(".grid > *").forEach(item => {
      item.classList.add("grid-item");
    });

    document.querySelectorAll(".grid-item").forEach(item => {
      _.__mapAttributeToCssVar(item, gridItemAttributeMap);
      if (item.dataset.backgroundImage) {
        item.style.backgroundImage =
          'url("' + item.dataset.backgroundImage + '")';
        item.removeAttribute("data-background-image");
      }
    });
  }

  _initAttributeTrigger(element) {
    const _ = this;
    const triggers = "hover enter leave".split(" ");
    const ns = "data-trigger";

    triggers.forEach(trigger => {
      const selector = `[data-${trigger}]`;
      if (trigger === "click") {
        return;
      } else if (trigger === "hover") {
        const eventIn = "mouseenter";
        const eventOut = "mouseleave";
        if (!hasSupport("touch")) {
          $(element || document)
            .on(`${eventIn}.${ns}`, selector, event => _.__triggerEnter(event))
            .on(`${eventOut}.${ns}`, selector, event => _.__triggerLeave(event))
            .off(`click.${ns}`);
        } else {
          $(element || document)
            .on(`click.${ns}`, selector, event => _.__triggerToggle(event))
            .off(`${eventIn}.${ns} ${eventOut}.${ns}`);
        }
      }
    });
  }

  getTriggerElements(event, context, trigger) {
    let element = event.currentTarget;
    if (element.getAttribute("data-target")) {
      let _dataElement =
        element.querySelector(element.dataset.target) ||
        element.closest(element.dataset.target);
      if (_dataElement) {
        element = _dataElement;
        void _dataElement;
      }
    }

    if (!context) {
      context = event.currentTarget.getAttribute(`data-${trigger}`);
    }

    return {
      element,
      context
    };
  }

  __triggerEnter(event, context) {
    let {
      element: triggerElement,
      context: triggerContext
    } = this.getTriggerElements(event, context, "hover");

    $(triggerElement).removeClass(triggerContext);

    void triggerElement.offsetWidth;

    $(triggerElement).addClass(triggerContext);
  }

  __triggerLeave(event, context) {
    let {
      element: triggerElement,
      context: triggerContext
    } = this.getTriggerElements(event, context, "hover");

    $(triggerElement).removeClass(triggerContext);
  }

  __triggerToggle(event, context) {
    let {
      element: triggerElement,
      context: triggerContext
    } = this.getTriggerElements(event, context, "hover");

    const $triggerElement = $(triggerElement);

    if (
      $(event.currentTarget).is('a[href]:not([href^="#"])') &&
      $triggerElement.hasClass(triggerContext)
    ) {
      return;
    }

    event.preventDefault();

    $triggerElement.toggleClass(triggerContext);
    if ($triggerElement.is(".nav-item")) {
      $triggerElement.siblings().removeClass(triggerContext);
    }
  }

  _initFlipping() {
    const $flipping = $(".flipping");
    const activeClass = "is-flipped";
    const defaultTimeout = 10000;
    const autoFlipSelector = "[data-flip]";
    const setFlipInterval = item => {
      let timeout = item.dataset.flip;
      if (!timeout) {
        return;
      }
      if (!isNumeric(timeout)) {
        timeout = defaultTimeout;
      }
      if (60 >= timeout) {
        timeout *= 1000;
      }
      item.interval = setInterval(
        element => element.classList.toggle(activeClass),
        timeout,
        item
      );
    };
    $flipping.closest(".row").css("overflow", "visible");
    $flipping
      .on("click", event => {
        event.stopPropagation();
        const $item = $(event.currentTarget);
        const isActive = $item.is(`.${activeClass}`);
        if (isActive) {
          $item.removeClass(activeClass);
        } else {
          $item
            .addClass(activeClass)
            .siblings()
            .removeClass(activeClass);
        }
        if (event.currentTarget.interval) {
          clearInterval(event.currentTarget.interval);
          event.currentTarget.removeAttribute("data-flip");
        }
      })
      .on("mouseenter", event => {
        if (event.currentTarget.interval) {
          clearInterval(event.currentTarget.interval);
          event.currentTarget.classList.add("is-paused");
        }
      })
      .on("mouseleave", event => {
        if ($(event.currentTarget).is(autoFlipSelector)) {
          event.currentTarget.classList.remove("is-paused");
          setFlipInterval(event.currentTarget);
        }
      });
    $flipping
      .filter(autoFlipSelector)
      .each((index, item) => setFlipInterval(item));
  }

  _initScrollSpy() {
    if (!this.scrollSpy.anchors || !this.scrollSpy.anchors.length) {
      return;
    }
    this.scrollSpy.container.scrollspy({
      target: this.scrollSpy.target,
      offset: parseInt(this.elements.header.height(), 10)
    });
  }

  _initSmoothScroll() {
    const _ = this;
    // Shorten anchor links for current document
    const documentUrl = "//" + window.location.host + window.location.pathname;
    $(`a[href*="${window.location.pathname}#"]`).each((i, link) => {
      link.setAttribute(
        "href",
        link
          .getAttribute("href")
          .replace(documentUrl, "")
          .replace(/^https?:(\/\/)?/i, "")
      );
    });
    $(document)
      .off("click.smooth-scroll")
      .on(
        "click.smooth-scroll",
        'a[href^="#"]' +
          ":not([data-slide])" +
          ":not([data-toggle])" +
          ":not(.gpmpn-page-link)",
        event => {
          event.preventDefault();
          if (!event.target.hash) {
            return;
          }
          try {
            let element = document.querySelector(event.target.hash);
            let offset = _.__getFullHeightOffset() || 0;
            let top = $(element).offset().top;
            $("html, body").animate(
              {
                scrollTop: top - offset
              },
              500
            );
          } catch (e) {}
        }
      );
  }

  _setSharrifClasses() {
    let $buttons = $(".shariff-button");
    $buttons.filter(".mailto, .printer").addClass("d-none d-md-inline-block");
    $buttons.filter(".printer").addClass("ml-auto");
  }

  _setMultiPadded() {
    // $('.carousel-background ~ .jumbotron > *, .parallax .jumbotron > *').addClass('padded-text');
    var $padded = $(".padded-text");
    if (!$padded.length) {
      return;
    }
    $padded
      .filter(":not(:has(span))")
      .wrapInner('<span class="padded-container"></span>');
    $("div, p", "span.padded-container").each(function() {
      var $element = $(this);
      $element.replaceWith($element.html());
    });
  }

  _setDefaultClasses() {
    const $main = $(".main");

    // Blockquotes.
    $("blockquote:not([class])", $main).addClass("blockquote");

    // Tables
    $("table:not([class])", $main).addClass("table");

    // Lists
    const $lists = $("ol, ul", $main).not("[class]");
    $lists.addClass("list-styled");
    $lists.filter("ol").addClass("list-numbered");

    // Margins
    let addMarginElements = $(
      "> *",
      ".row:not(.row-intro,.row-o-equal-height)"
    )
    .add(".gallery");
    const noMarginClass = (index, element) => {
      const elementClass = element.getAttribute("class") || "";
      return (
        elementClass.match(/mb(-(sm-|md|lg|xl))?-\d/) ||
        elementClass.match(/form-/)
      );
    };
    addMarginElements
      .not(noMarginClass)
      .not(":last-child")
      .addClass("mb-4 mb-sm-0");

    $(".cta")
      // .add(".media")
      .not(noMarginClass)
      .not(":last-child")
      .addClass("mb-3");

    $(":last-child", ".card-body")
      .not(noMarginClass)
      .addClass("mb-0");

    $("> *", ".row-o-equal-height")
      .not(noMarginClass)
      .addClass("mb-4");

    // Images
    $("img.img-squared").each((i, item) => {
      $(item)
        .wrap('<div class="img-squared" />')
        .removeClass("img-squared");
    });

    $(".templatera_shortcode")
      .contents()
      .unwrap();
  }

  _setImageFocus(el, force) {
    if (
      true !== force &&
      "undefined" !== typeof this.state.imageFocus &&
      this.state.imageFocus
    ) {
      return;
    }
    if ("undefined" === typeof el || !el.length) {
      el = $(
        'img[src*="fp="],[data-vc-parallax-image*="fp="] .vc_parallax-inner,.parallax-af .vc_parallax-inner'
      );
    }
    const _ = this;
    $.each(el, function() {
      let src =
        this.tagName === "IMG"
          ? this.src
          : $(this)
              .css("background-image")
              .replace("url(", "")
              .replace(")", "")
              .replace(/"/gi, "");
      if (!src) {
        return;
      }
      let focus = src.match(/(?:\?|&)fp=([\d.]+)_([\d.]+)(?:&|$)/);
      if (focus) {
        $(this)
          .addClass("has-focus-point")
          .attr("data-focus", focus[1] + ";" + focus[2]);
      }
    })
      .promise()
      .done(function() {
        const selector = "[data-focus]";
        const elements = el ? el.filter(selector) : $(selector, document);
        elements.each(function() {
          let $el = $(this);
          let focus = ($el.data("focus") || "0.5;0.5").split(";");
          $el.removeAttr("data-focus");
          if (0.5 === focus[0] && 0.5 === focus[1]) {
            return;
          }
          $el.css(
            this.tagName === "IMG" ? "object-position" : "background-position",
            100 * focus[0] + "% " + 100 * focus[1] + "%"
          );
        });
        _.state.imageFocus = true;
      });
  }

  _setImageBlend() {}

  _addDefinitionListNavbar() {
    const $lists = $("dl");

    $lists.each(function() {
      let $list = $(this);

      if ($list.prev(".pagination").length || $list.prev("nav").length) {
        return;
      }

      let $terms = $("dt", $list);
      let termStrings = [];
      let anchors = {};

      $terms.each(function(i, term) {
        let $term = $(term);
        let termString = $term.text();
        let firstChar = termString.charAt(0).toLowerCase();

        termStrings.push(termString);

        if (!(firstChar in anchors)) {
          $term.attr("id", "letter-" + firstChar).addClass("sticky-offset");
          anchors[firstChar] = term;
        }

        $term.addClass("term-" + firstChar);
      });

      let $pagination = $('<ul class="pagination pagination-sm"></ul>');

      $.each(Object.keys(anchors), function() {
        $('<a class="page-link"></a>')
          .attr({
            href: "#letter-" + this,
            "data-turbolinks": "false"
          })
          .text(this.toUpperCase())
          .wrap('<li class="page-item"></li>')
          .appendTo($pagination);
      });

      $pagination.wrap("<nav />").insertBefore($list);
    });
  }

  _setTargetBlank() {
    // remove subdomain of current site's url and setup regex
    const internal = new RegExp(location.host.replace("www.", ""), "i");

    // then, grab every link on the page
    let a = document.getElementsByTagName("a");
    for (let i = 0; i < a.length; i++) {
      // set the host of each link
      let href = a[i].host;
      // make sure the href doesn't contain current site's host
      if (!internal.test(href)) {
        // if it doesn't, set attributes
        a[i].setAttribute("target", "_blank");
        a[i].setAttribute("rel", "noopener");
      }
    }
  }

  _setFileSizeInfo() {
    const $assets = $('a[href$=".pdf"],a[href$=".zip"]').not(
      "[data-file-size]"
    );

    // @http://stackoverflow.com/a/18650828
    const _bytesToSize = function(bytes) {
      if (isNaN(bytes)) {
        return;
      }
      if (0 === bytes) {
        return "0 byte";
      } else if (
        "number" !== typeof bytes &&
        !("" + bytes).match(/^[\d,.]+$/)
      ) {
        return bytes;
      }
      const k = 1000;
      const sizes = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + " " + sizes[i];
    };
    // @http://shipoint.com/2010/09/20/show-document-file-size-using-jquery/
    const _appendFileSizeInfo = function() {
      // just get local files
      if (
        undefined === typeof this.hostname ||
        (this.hostname || ":").split(":")[0] !== location.hostname.split(":")[0]
      ) {
        return;
      }
      let $el = $(this);
      let _fS = $el.data("file-size");
      if (!_fS) {
        $.ajax({
          type: "HEAD",
          url: $el.attr("href"),
          complete: function(xhr) {
            _fS =
              200 === xhr.status ? xhr.getResponseHeader("content-length") : -1;
            $el.data("file-size", _fS);
            $el.attr("data-file-size", _bytesToSize(_fS));
          }
        });
      }
      $el.attr("data-file-size", _bytesToSize($el.data("file-size")));
      let m;
      $el.attr(
        "data-file-type",
        (m = this.href.match(/\.(pdf|zip)$/)) ? m[1].toUpperCase() : null
      );
    };
    $assets.each(_appendFileSizeInfo);
  }
}



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/Circular.js